import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import {
  ActualTask,
  AllocatedTask,
  BloodOxygen,
  BloodPressure,
  BloodPressureAndWeight,
  Catalogue,
  DoctorDashboard,
  ExtendedDoctorDashboard,
  LabResult,
  LabResultsEditModel,
  LabSumDataItem,
  LastMeasuredData,
  MsData,
  NormalBloodPressure,
  PatientData,
  PatientDataDetails,
  PatientDataDetailsModel,
  PatientDataFunc,
  SendMessageModel,
  TaskEvaluation,
  TaskSablon
} from '../services/webapiclient.service';
import { ErrorService } from '../services//error.service';
import { BoolResult, StringResult } from '../module-thryve/thryve.service';
import { isNgTemplate } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(
    private patientDataFunc: PatientDataFunc,
    private errorService: ErrorService

  ) { }


  async getPatient(id: string) {
    let model: PatientData = {} as PatientData;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.get(id).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getAllPatient(id: string) {
    let model: PatientData[] = {} as PatientData[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getAll().pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async upsertPatient(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.upsert(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async updatePatient(id: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.update(id, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async saveDoctorAndProviderId(id: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.saveDoctorAndProviderId(id, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async saveProviderConfirmation(id: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.saveProviderConfirmation(id, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async getCatalogue(id: string, isGP: boolean) {
    let model: Catalogue[] = {} as Catalogue[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getCatalogue(id, isGP).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async getDoctorDashboardData(id: string) {
    let model: ExtendedDoctorDashboard = {} as ExtendedDoctorDashboard;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getDoctorDashboardData(id).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async getLastMeasuredData(id: string) {
    let model: LastMeasuredData[] = {} as LastMeasuredData[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getLastMeasuredData(id).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  //Háziorvosi kapcsolat megszüntetése a beteg részéröl
  async cancelGpConnection(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.cancelGpConn(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }


  //Kezelés megszüntetése
  async cancelTreatment(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.cancelTreatment(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  //Kezelés elutasítása
  async denyTreatment(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.denyTreatment(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  //Üzenet küldése a betegnek vagy jegyzetek
  async sendMessage(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.sendMessage(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  //Jegyzetek beolvasása
  async getNotes(doctorId: string, patinetId: string) {
    let model: SendMessageModel[] = {} as SendMessageModel[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getNotes(doctorId, patinetId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async deleteNote(userId: string, id: number) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteNote(userId, id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  //details

  async getDetails(id: string, code: string) {
    let model: PatientDataDetails[] = {} as PatientDataDetails[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getDetails(id, code).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getDetailsModel(patientId: string) {
    let model: PatientDataDetailsModel[] = {} as PatientDataDetailsModel[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getDetailsModel(patientId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async insertDetail(id: string, code: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.insertDetail(id, code, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async updateDetail(id: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.updateDetail(id, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async deleteDetail(id: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteDetail(id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  //subDetails

  async getSubDetails(id: string) {
    let model: PatientDataDetails[] = {} as PatientDataDetails[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getSubDetails(id).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async insertSubDetail(patientId: string, detailId: string, code: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.insertSubDetail(patientId, detailId, code, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async updateSubDetail(id: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.updateSubDetail(id, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async deleteSubDetail(id: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteSubDetail(id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  //vérnyomás adatok

  async getBloodPressureList(id: string, startDate: string, endDate: string) {
    let model: BloodPressure[] = {} as BloodPressure[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getBloodPressureList(id, startDate, endDate).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getBloodPressureListAndWeight(id: string, startDate: string, endDate: string) {
    let model: BloodPressureAndWeight[] = {} as BloodPressureAndWeight[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getBloodPressureAndWeightList(id, startDate, endDate).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getNormalBloodPressure(id: string) {
    let model: NormalBloodPressure = {} as NormalBloodPressure;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getNormalBloodPressure(id).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async addBloodPressure(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.addBloodPressure(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async updateBloodPressure(id: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.updateBloodPressure(id, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async deleteBloodPressure(userId: string, id: number) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteBloodPressure(userId, id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  //véroxygén

  async getBloodOxygenList(id: string, startDate: string, endDate: string, descOrder: boolean) {
    let model: BloodOxygen[] = {} as BloodOxygen[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getBloodOxygenList(id, startDate, endDate, descOrder).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async addBloodOxygen(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.addBloodOxygen(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async updateBloodOxygen(id: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.updateBloodOxygen(id, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async deleteBloodOxygen(userId: string, id: number) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteBloodOxygen(userId, id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }


  //labor eredmények

  async getLaborResults(userId: string) {
    let model: LabResult[] = {} as LabResult[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getLaborResults(userId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getLabSumData(userId: string) {
    let model: LabSumDataItem[] = {} as LabSumDataItem[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getLabSumData(userId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async getLabResultsCreate(userId: string) {
    let model: LabResultsEditModel = {} as LabResultsEditModel;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getLabResultsCreate(userId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getLabResultsUpdate(userId: string, webId: string) {
    let model: LabResultsEditModel = {} as LabResultsEditModel;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getLabResultsUpdate(userId, webId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async updateLabData(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.updateLabData(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async deleteLabData(userId: string, webId: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteLabData(userId, webId).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async checkLabDataRange(appReference: string, selectedUnit: string, labValue: number) {
    let model: BoolResult = {} as BoolResult;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.checkLabDataRange(appReference, selectedUnit, labValue).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  //Feladatok

  async insertTask(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.insertTask(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }
  async insertTaskSablon(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.insertTaskSablon(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
            resolve(result);
        }
      })
    });
  }
  async updateTaskSablon(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.updateTaskSablon(values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async getTaskList(userId: string) {
    let model: AllocatedTask[] = {} as AllocatedTask[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getTasks(userId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getUserCountry(providerId: number) {
    let model: StringResult = {} as StringResult;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.GetPatientCountry(providerId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }  
  async deleteTaskSablon(doctorId: string, id: number) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteTaskSablon(doctorId, id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async getTaskSablon(doctorId: string, taskSablonType: number) {
    let model: TaskSablon[] = {} as TaskSablon[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getTaskSablon(doctorId,taskSablonType).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }  
  async getActualTaskList(userId: string, actual: boolean) {
    let model: ActualTask[] = {} as ActualTask[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getActualTasks(userId, actual).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async startActualTask(userId: string, id: number) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.startTask(userId, id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async deleteTask(userId: string, id: number) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteTask(userId, id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async getTasksEvaluationList(userId: string) {
    let model: TaskEvaluation[] = {} as TaskEvaluation[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getTasksForEvaluation(userId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }
  async getTaskSheetList(userId: string, taskId: number) {
    let model: TaskEvaluation[] = {} as TaskEvaluation[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getTaskSheet(userId, taskId).pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async setTaskToEvaluated(userId: string, taskId: number, providerId: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.setTaskToEvaluated(userId, taskId, providerId).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }


  //mySignals

  async getLastMeasurement() {
    let model: MsData[] = {} as MsData[];
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getLastMeasurement().pipe(first()).subscribe({
        next: (v) => model = v,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async saveMeasurements(userId: string, values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.saveMeasurements(userId, values).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async uploadFile(myFile: FormData, Id: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.upload(myFile, Id).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async getUploadedFileURL(uploadFileId: string) {
    let model: string;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.getUploadedFileUrl(uploadFileId).pipe(first()).subscribe({
        next: (v) => model = v.result,
        error: (e) => reject(e.message),
        complete: () => resolve(model)
      })
    });
  }

  async deleteUploadFile(uploadFileId: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.deleteUploadFile(uploadFileId).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }

  async setLanguage(userId: string, lang: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.patientDataFunc.setLanguage(userId, lang).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
    });
  }


}
